import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

/**
 * Restricts the sales dashboard (orders + contact messages) to local staff who
 * may use it: admins, or accounts flagged canAccessOrders.
 *
 * Deliberately not adminGuard. Admin means administration — users, categories,
 * files, the gateway list — and gating the dashboard on it meant anyone who
 * could read an order could also delete a file. The backend enforces the same
 * rule (fyesDashboardRequired); this only keeps people off a page they could
 * not load data for.
 */
export const dashboardGuard: CanActivateFn = () => {
    const session = inject(SessionService);
    const router = inject(Router);

    if (!session.isLoggedIn()) {
        router.navigate(['/']);
        return false;
    }
    if (!session.isLocal() || !session.canAccessOrders()) {
        router.navigate(['/']);
        return false;
    }
    return true;
};
